// extracted by mini-css-extract-plugin
module.exports = {"internalLinkHeading":"InstitutionTemplate_internalLinkHeading__nMUOd","internalLinksCta":"InstitutionTemplate_internalLinksCta__aAZS5"};